import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Box, Grid } from "@mui/material";
import { getAllGoalsAsync } from "../../../redux/async.api";
import CustomComponentLoader from "../../../components/CustomComponentLoader/CustomComponentLoader";
import GoalList from "./GoalList";

function SwitchGoal({ setOpen }) {
  const dispatch = useDispatch();
  const { goalLoader, getAllGoals } = useSelector((state) => state.goal);
  const [expandedCourseId, setExpandedCourseId] = useState(null);

  useEffect(() => {
    dispatch(getAllGoalsAsync());
  }, []);

  return (
    <>
      <Box
        sx={{
          pt: 2,
          pb: 4,
          width: "100%",
          height: "auto",
          overflowY: "auto",
        }}
      >
        {goalLoader ? (
          <>
            <CustomComponentLoader padding="0" size={40} />
          </>
        ) : (
          <Grid container sx={{ pr: "20px" }} item spacing={2}>
            {getAllGoals?.length > 0 &&
              getAllGoals?.map((course) => {
                return (
                  <GoalList
                    key={course.id}
                    item={course}
                    goalLoader={goalLoader}
                    expandedCourseId={expandedCourseId}
                    // handleExpand={handleExpand}
                    setExpandedCourseId={setExpandedCourseId}
                    setOpen={setOpen}
                  />
                );
              })}
          </Grid>
        )}
      </Box>
    </>
  );
}

export default SwitchGoal;
